import type { Reducer } from 'redux';

import type { LoadEcsTreatmentsFulfilledAction } from '../../domains/ecs/actions.types';

import type { EcsConfig } from './types';

export type EcsConfigAction = LoadEcsTreatmentsFulfilledAction;

const initialState: EcsConfig = {
  configIds: {},
  etag: '',
};

const reducer: Reducer<EcsConfig, EcsConfigAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'FEATURE_FLIGHTING.LOAD_ECS_TREATMENTS_FULFILLED':
      return action.payload.ecsConfig;
    default:
      return state;
  }
};

export default reducer;
